@if(loader){
<app-loader></app-loader>
}
<p-card [header]="isEditMode ? 'Update Purchase Order' : 'Create Purchase Order'">
    <div>
        <form [formGroup]="purchaseOrderForm">
            <div class="field col-12 flex justify-content-between align-items-center">
                <div class="flex justify-content-start">
                    <div *ngIf="purchaseOrderForm.controls.PurchaseOrder_Status.value !== 'Reject PR'">
                        @if(purchaseOrderForm.controls.PurchaseOrder_Status.value === 'Pending Level 1 Approval' ){
                        <p-button label="Save" icon="pi pi-save" size="small" (click)="showSaveOptions()"
                            class="mr-2"></p-button>}
                        <p-dialog header="Confirm Save" [(visible)]="saveConfirmVisible" [modal]="true"
                            [style]="{width: '350px'}">
                            <p style="color: black;">Do you want to save this Purchase Order?</p>
                            <ng-template pTemplate="footer">
                                <p-button label="Cancel" icon="pi pi-times" severity="danger"
                                    (click)="saveConfirmVisible=false"></p-button>
                                <p-button label="Save" icon="pi pi-check" (click)="confirmSave()"></p-button>
                            </ng-template>
                        </p-dialog>

                        @if (canAdminApprove()) {

                        <p-button label="Reject PO" icon="pi pi-times-circle" severity="danger" size="small"
                            class="p-button-sm mr-2" (click)="showPORejectDialog()">
                        </p-button>

                        <p-button label="Submit PO" icon="pi pi-arrow-circle-up" size="small"
                            (click)="showSaveOptionsPopup()" class="mr-2">
                        </p-button>

                        }


                        @if(purchaseOrderForm.controls.PurchaseOrder_Status.value === POStatus.PendingLevel1Approval
                        && isEditMode && isPOAdmin && isPoAdminEnabled) {

                        <p-button label="Reject" icon="pi pi-times-circle" severity="danger" size="small"
                            class="p-button-sm mr-2" (click)="performApproval('Reject')">
                        </p-button>

                        <p-button label="Approve" icon="pi pi-check" size="small" class="mr-2"
                            (click)="showApproveOptions()">
                        </p-button>
                        }

                    </div>

                    @if(purchaseOrderForm.controls.PurchaseOrder_Status.value === 'Approved' ||
                    purchaseOrderForm.controls.PurchaseOrder_Status.value === 'Amended' && !isPOAdmin
                    ){
                    <p-button label="Update" severity="info" icon="pi pi-arrow-circle-up" size="small" class="mr-2"
                        (click)="onUpdateClick()">
                    </p-button>
                    }
                    <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" class="p-button-sm ml-2"
                        (click)="Cancel()"></p-button>
                </div>

                <div class="flex align-items-center gap-3">
                    <label class="block label-required" style="font-weight: bold;">Required Field</label>

                    <p-button label="More" icon="pi pi-angle-down" iconPos="right" size="small"
                        (click)="moreMenu.toggle($event)"></p-button>
                    <p-menu #moreMenu [popup]="true" [model]="moreMenuItems"></p-menu>
                </div>
            </div>


            <div class="grid mt-4" [style.opacity]="isFormLocked ? '1.6' : '1'"
                [style.pointer-events]="isFormLocked ? 'none' : 'auto'">
                <div class="col">

                    <div class="field text-left">
                        <label for="Warehouse" class="label-required display">{{unitLabel}} Name</label>
                        <p-autoComplete [dropdown]="(products.length > 0)? false : true" [forceSelection]="true"
                            [readonly]="products.length > 0" formControlName="warehouseName" styleClass="w-full"
                            [suggestions]="filtewarehouse" (completeMethod)="filteWarehouse($event)"
                            (onSelect)="SelectedWarehouse($event)" field="warehouseName" placeholder="Search"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.warehouseName.errors }"
                            (keydown.enter)="focusNextInput($event)">
                            <ng-template let-item pTemplate="item">
                                <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
                            </ng-template>
                        </p-autoComplete>
                        <small *ngIf="submitted && formControls.warehouseName.errors" id="name-error"
                            class="text-red-500">Required field.</small>
                    </div>

                    <div class="field text-left">
                        <label for="address">{{unitLabel}} Address</label>
                        <div class="p-inputgroup p-lookup">
                            <input pInputText placeholder="{{unitLabel}} Address" id="address" readonly
                                formControlName="warehouseAddress" styleClass="w-full" />
                        </div>
                    </div>

                    <div class="field text-left">
                        <!-- <div class="label-with-outstanding"> -->
                        <label for="vendorName" class="label-required display">
                            Vendor
                        </label>

                        <!-- <span *ngIf="vendorOutstandingPayables !== null && vendorOutstandingPayables !== undefined"
                                class="outstanding-indicator vendor">
                                <i class="pi pi-exclamation-triangle"></i>
                                Outstanding Payables : {{ vendorOutstandingPayables | currency:'INR':'symbol':'1.2-2':'en-IN' }}
                            </span> -->
                        <!-- </div> -->
                        <span class="p-fluid">
                            <div style="display: flex;">
                                <p-autoComplete formControlName="vendorName" [readonly]="products.length > 0"
                                    (onSelect)="setVendor($event)" [suggestions]="VendorList" Style="width: 250px;"
                                    (completeMethod)="autosearchVendor($event)" field="vendorName"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.vendorCode.errors }"
                                    (keydown.enter)="focusNextInput($event)" [forceSelection]="true">
                                    <ng-template let-item pTemplate="item">
                                        <span>{{item.vendorCode}} - {{item.vendorName}}</span>
                                    </ng-template>
                                </p-autoComplete>
                                <button type="button" [disabled]="products.length > 0" pButton pRipple id="vendorButton"
                                    (click)="getVendor()" icon="pi pi-search" styleClass="p-button-warn"
                                    style="margin-left: 10px;"></button>
                                <p-button (click)="createQuickVendor()" [disabled]="products.length > 0"
                                    id="quickVendor" class="p-button-outlined ml-2 " icon="pi pi-user-plus"
                                    severity="info"></p-button>
                            </div>
                            <small *ngIf="submitted && formControls.vendorCode.errors" id="name-error"
                                class="text-red-500">Required
                                field.</small>
                        </span>
                    </div>


                    <div class="field text-left">
                        <label for="address">Vendor Address</label>
                        <div class="p-inputgroup p-lookup">
                            <input pInputText placeholder="Vendor Address" id="address" readonly formControlName="add"
                                styleClass="w-full" (keydown.enter)="focusNextInput($event)" />
                        </div>
                    </div>

                </div>
                <div class="col">



                    <div class="field text-left">
                        <label for="website" class="label-required display">Purchase Order Number</label>
                        <div style="display: flex; align-items: center;">
                            <input pInputText placeholder="e.g 307" class="w-full" (blur)="checkPurchaseNumber()"
                                formControlName="purchaseOrderNumber" [readonly]="isEditMode || !manualEntryChecked"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.purchaseOrderNumber.errors }"
                                (keydown.enter)="focusNextInput($event)" />
                            <ng-container *ngIf="!isEditMode">
                                <div style="margin-left: 10px;">
                                    <p-checkbox formControlName="manualEntry" *ngIf="products.length == 0"
                                        (onChange)="manualEntry()" [binary]="true" label="Manual Entry"
                                        value="true"></p-checkbox>
                                </div>
                            </ng-container>
                        </div>
                        <small *ngIf="submitted && formControls.purchaseOrderNumber.errors" id="name-error"
                            class="text-red-500">Required field.</small>
                    </div>

                    <div class="field text-left">
                        <label for="ShipToCustomerCode">Ship To Customer Code</label>
                        <span class="p-fluid">
                            <div style="display: flex;">
                                <p-autoComplete formControlName="ShipToCustomerCode" [readonly]="products.length > 0"
                                    (onSelect)="setShipTo($event)" [suggestions]="ShipTocustomerList"
                                    [forceSelection]="true" (completeMethod)="autosearchShiptoCustomer($event)"
                                    field="customerCode" Style="width: 285px;"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ShipToCustomerCode.errors }"
                                    (keydown.enter)="focusNextInput($event)">
                                    <ng-template let-item pTemplate="item">
                                        <span>{{item.customerCode}} - {{item.customerName}}</span>
                                    </ng-template>
                                </p-autoComplete>
                                <button type="button" [disabled]="products.length > 0" pButton pRipple
                                    id="shipTocustomer" (click)="openShipToCustomerLookup()" icon="pi pi-search"
                                    styleClass="p-button-warn" style="margin-left: 10px;"></button>
                                <p-button (click)="createQuickCustomer()" [disabled]="products.length > 0"
                                    id="quickShipToCustomer" class="p-button-outlined ml-2 " icon="pi pi-user-plus"
                                    severity="info"></p-button>
                            </div>
                        </span>
                    </div>


                    <div class="field text-left">
                        <label for="ShipToCustomer">Ship To Customer Name</label>
                        <input pInputText formControlName="ShipToCustomer" readonly class="w-full"
                            (keydown.enter)="focusNextInput($event)" />
                    </div>

                    <div class="field text-left">
                        <label for="Department">{{DeptLabel}}</label>
                        <p-autoComplete [dropdown]="true" formControlName="departmentName" [forceSelection]="true"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.departmentName.errors }"
                            styleClass="w-full p-inputtext-sm" [suggestions]="filterDepartments"
                            (completeMethod)="filterDepartment($event)" (onSelect)="SelectedDepartment($event)"
                            field="departmentName" placeholder="Search {{DeptLabel}}"
                            (keydown.enter)="focusNextInput($event)">
                            <ng-template let-item pTemplate="item">
                                <span>{{item.departmentCode}} - {{item.departmentName}}</span>
                            </ng-template>
                        </p-autoComplete>
                    </div>

                </div>


                <div class="col">

                    <div class="field text-left">
                        <label for="createdDate" class="label-required display">PO Date</label>
                        <div class="p-inputgroup p-lookup">
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="createdDate"
                                [showIcon]="true" placeholder="Select Date"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.createdDate.errors }"
                                styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                        </div>
                        <small *ngIf="submitted && formControls.createdDate.errors" id="name-error"
                            class="text-red-500">Required field.</small>

                    </div>

                    <div class="field text-left">
                        <label for="requestedDate" class="label-required display">Requested Date</label>
                        <div class="p-inputgroup p-lookup">
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="requestedDate"
                                [showIcon]="true" placeholder="Select Date"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.requestedDate.errors }"
                                styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                        </div>
                        <small *ngIf="submitted && formControls.requestedDate.errors" id="name-error"
                            class="text-red-500">Required field.</small>
                    </div>

                    <div class="field text-left">
                        <label for="amendmentNo">Amendment Number</label>
                        <input pInputText formControlName="amendmentNo" class="w-full"
                            (keydown.enter)="focusNextInput($event)" />
                    </div>


                    <div class="field text-left">
                        <label for="amendmentDate">Amendment Date</label>
                        <div class="p-inputgroup p-lookup">
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="amendmentDate"
                                [showIcon]="true" placeholder="Select Date"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.amendmentDate.errors }"
                                styleClass="w-full" (keydown.enter)="focusNextInput($event)">
                            </p-calendar>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div>
        <form [formGroup]="purchaseOrderLineItemForm">
            <p-tabView>
                <p-tabPanel header="Order Lines">
                    <div class="grid" style="margin-left: -15px;" *ngIf="showPOLineItemSection">

                        <div class="col-fixed" style="width: 150px; display: flex; align-items: center;">
                            @if(
                            purchaseOrderForm.controls.PurchaseOrder_Status.value === POStatus.Ready ||
                            purchaseOrderForm.controls.PurchaseOrder_Status.value === POStatus.PendingLevel1Approval
                            ||
                            purchaseOrderForm.controls.PurchaseOrder_Status.value === POStatus.Approved
                            ){
                            <p-button icon="pi pi-plus" (onClick)="createQuickProduct()" [link]="true"
                                label="New Product" [size]="'small'" [style]="{'white-space':'nowrap'}"></p-button>
                            }
                        </div>

                        <div class="col">
                            <div style="display: flex; align-items: center; justify-content: space-around;">
                                <p-image [src]="this.previewImage" alt="product" width="40" [preview]="true"></p-image>
                                <p-autoComplete #productCodeAutoComplete #productCodeInputRef
                                    formControlName="productCode" [placeholder]="placeholder"
                                    [inputStyle]="{'height':'40px'}" (onSelect)="setProduct($event)"
                                    [suggestions]="filterProductList" (completeMethod)="autosearchProduct($event)"
                                    field="customerCode" [appendTo]="'body'" [forceSelection]="true">
                                    <ng-template let-item pTemplate="item" class="text-left">
                                        <span>{{item.productCode}} - {{item.productName}}</span>
                                    </ng-template>
                                </p-autoComplete>
                                <div style="margin-left: 20px; text-align: center;">
                                    <p style="margin: 0; font-weight: bold; font-size: 14px;">Q-Avail</p>
                                    <p style="margin: 0; font-size: 14px;">{{QAvail}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <input pInputText formControlName="productDescription" readonly placeholder="Product Name"
                                class="w-full p-inputtext-sm" style="height: 40px;"
                                (keydown.enter)="focusNextInput($event)" />
                        </div>

                        <div class="col">
                            <div class="field text-left" style="display: flex; align-items: center;">
                                <span style="flex-grow: 1; margin-right: 10px;">
                                    <input pInputText id="Qty" type="number" [formControlName]="getFormControlName()"
                                        placeholder="Qty" min="0" class="w-full p-inputtext-sm" style="height: 40px;"
                                        (keydown.enter)="focusNextInput($event)" />
                                </span>
                                <p-button label="Add" (onClick)="addProduct()"
                                    [disabled]="!purchaseOrderLineItemForm.controls.productCode.value ||
                            !purchaseOrderLineItemForm.controls.productDescription.value ||
                            !(productCostCalculationType === 'qty' ? purchaseOrderLineItemForm.controls.productQty.value : purchaseOrderLineItemForm.controls.productWgt.value)"
                                    [raised]="true" [size]="'small'" severity="info"></p-button>
                                <span style="margin-left: 10px;">
                                    <p-button icon="pi pi-trash" (click)="deletePOLineitem()"
                                        [disabled]="selectedProduct.length === 0" [raised]="true" [size]="'small'"
                                        severity="danger"></p-button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <p-table #dt1 [value]="products | slice:0" responsiveLayout="scroll" class="w-full m-5"
                        styleClass="p-datatable-sm" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,15, 20]"
                        [paginator]="true" [(selection)]="selectedProduct">
                        <!-- (onEditComplete)="onProductEdit($event)"> -->
                        <ng-template pTemplate="header">
                            <tr>
                                <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                                <th>Sr No</th>
                                <th pSortableColumn="ProductCode">Code <p-sortIcon field="ProductCode"></p-sortIcon>
                                </th>
                                <th>Product Name</th>
                                <td></td>
                                <th>UOM </th>
                                <!-- <th>Weight</th> -->
                                <th>Qty</th>
                                <th class="text-right">Cost(₹)</th>
                                <th class="text-center">Amount(₹)</th>
                                <th class="text-right">Disc (%) </th>
                                <th class="text-center">NetAmount(₹)</th>
                                <th>GST(%)</th>
                                <th class="text-right">GST(₹)</th>
                                <th class="text-center">LineAmount(₹)</th>
                                <!-- <th>Remark</th> -->
                                <th>Date Required</th>
                                <th>Project</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product let-i="rowIndex">
                            <tr>
                                <td>
                                    <p-tableCheckbox [value]="product"></p-tableCheckbox>
                                </td>
                                <td>{{i+1}}</td>
                                <td class="text-blue-500 underline" style="cursor: pointer;" [pEditableColumn]="product"
                                    pEditableColumnField="ProductCode" (click)="viewProduct(product)">
                                    {{ product.ProductCode }}
                                </td>
                                <td> {{ product.ProductDescription }}</td>
                                <!-- <td [pEditableColumn]="product" pEditableColumnField="ProductDescription">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <input pInputText type="text" (blur)="onProductEdit(product)"
                                                    [(ngModel)]="product.ProductDescription"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (keydown.enter)="focusNextInput($event)" />
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <span *ngIf="product.ProductDescription.length > 20; else fullText">
                                                    {{ product.ProductDescription }}
                                                </span>
                                                <ng-template #fullText>
                                                    {{ product.ProductDescription }}
                                                </ng-template>
                                            </ng-template>
                                        </p-cellEditor>
                                    </td> -->
                                <td><span class="text-lg cursor-pointer" (click)="showSpecification(product)"><i
                                            class="pi pi-flag-fill"></i></span></td>
                                <!-- <td>{{product.Uom}}</td> -->
                                <td [pEditableColumn]="product" [pEditableColumnField]="'uom'">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <div class="p-inputgroup p-lookup">
                                                <input type="text" pInputText class="p-inputtext"
                                                    [(ngModel)]="product.Uom" [ngModelOptions]="{ standalone: true }"
                                                    [disabled]="true" />
                                                <button type="button" pButton pRipple icon="pi pi-search"
                                                    styleClass="p-button-warn"
                                                    (click)="showProductUom(product)"></button>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{product.Uom}}
                                        </ng-template>
                                    </p-cellEditor>

                                </td>
                                <!-- <td>{{product.Weight | number: '1.2-2'}}</td> -->


                                <!-- <td [pEditableColumn]="product" pEditableColumnField="Weight">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <input pInputText type="number" class="p-inputtext-sm" min="0"
                                                    [(ngModel)]="product.Weight" (blur)="onProductEdit(product)"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (keydown)="onKeydown($event,product)" />
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                &nbsp;{{ product.Weight }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td> -->
                                <td [pEditableColumn]="product" pEditableColumnField="Quantity">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="number" min="1" (blur)="onProductEdit(product)"
                                                [(ngModel)]="product.POQuantity" [ngModelOptions]="{ standalone: true }"
                                                (keydown)="onKeydown($event,product)" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ product.POQuantity }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td class="text-right" [pEditableColumn]="product" pEditableColumnField="Cost"
                                    class="text-right">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="number" min="0" (blur)="onProductEdit(product)"
                                                [(ngModel)]="product.Cost" [ngModelOptions]="{ standalone: true }"
                                                (keydown)="onKeydown($event,product)" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            &nbsp;{{ product.Cost.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                            maximumFractionDigits: 2}) }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>

                                <td class="text-center">{{product.ExtendedCost.toLocaleString('en-IN', {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2})}} </td>

                                <td class="text-right" [pEditableColumn]="product" pEditableColumnField="Discount">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="number" min="0" max="100" step="0.01"
                                                [(ngModel)]="product.Discount"
                                                (ngModelChange)="checkLineItemDiscounts()"
                                                [ngModelOptions]="{ standalone: true }"
                                                (blur)="onProductEdit(product)" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ (product.Discount ?? 0) | number:'1.0-2' }}%
                                        </ng-template>
                                    </p-cellEditor>
                                </td>

                                <!-- <td> <p-calendar dateFormat="dd/mm/yy" (ngModelChange)="onProductEdit(product)"  [showIcon]="true" [iconDisplay]="'input'" [(ngModel)]="product.DateRequired"
                                              [touchUI]="true" [readonlyInput]="true" [ngModelOptions]="{standalone: true}" /></td> -->

                                <td class="text-center">{{product.NetAmount.toLocaleString('en-IN', {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2})}} </td>
                                <td>{{product.GSTRate}}</td>
                                <td class="text-right">{{ (product.NetAmount * product.GSTRate /
                                    100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                    }}</td>
                                <td class="text-center">{{product.LineTotal.toLocaleString('en-IN', {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2})}} </td>

                                <!-- <td><span class="text-lg cursor-pointer" (click)="showComment(product)"><i
                                            class="pi pi-comment"></i></span></td> -->

                                <!--project in po lineitem-->
                                <td style="display: flex; justify-content: center; max-width: 134px;">
                                    <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy"
                                        (blur)="onProductEdit(product)" [(ngModel)]="product.DateRequired"
                                        (keydown)="onKeydown($event, product)" [ngModelOptions]="{ standalone: true }"
                                        [showIcon]="true" styleClass="w-full" (keydown.enter)="focusNextInput($event)"
                                        appendTo="body">
                                    </p-calendar>
                                </td>

                                <td [pEditableColumn]="product" [pEditableColumnField]="'project'">
                                    <p-cellEditor>

                                        <ng-template pTemplate="input">
                                            <div class="p-inputgroup">
                                                <input type="text" pInputText class="p-inputtext"
                                                    [(ngModel)]="product.projectBoMName"
                                                    [ngModelOptions]="{ standalone: true }" placeholder="Add Project"
                                                    readonly />
                                                <button type="button" pButton pRipple icon="pi pi-search"
                                                    styleClass="p-button-warn" (click)="getProjectLookup(product)">
                                                </button>
                                            </div>
                                        </ng-template>

                                        <ng-template pTemplate="output">
                                            {{ product.projectBoMName || 'Add Project' }}
                                        </ng-template>

                                    </p-cellEditor>
                                </td>

                                <td></td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <form [formGroup]="purchaseOrderForm" class="grid">
                                <div class="col-5 md:col-8">
                                    <div class="grid formgrid w-full">
                                        <div class="field col-12 md:col-4">
                                            <label>Freight Charges(₹)</label>
                                            <input type="text" pInputText class="w-full"
                                                formControlName="FreightAmount">
                                        </div>
                                        <div class="field col-12 md:col-4">
                                            <label for="GSTRateOnFreight" class="font-semibold mb-1 block">Rate on
                                                Freight</label>
                                            <p-dropdown id="GSTRateOnFreight" class="w-full" [options]="gstOptions"
                                                optionLabel="label" optionValue="value" placeholder="Select GST"
                                                formControlName="GSTRateOnFreight">
                                            </p-dropdown>
                                        </div>
                                        <div class="field col-12 md:col-4">
                                            <label>GST on Freight(₹)</label>
                                            <input type="text" pInputText class="w-full" formControlName="GSTOnFreight"
                                                readonly>
                                        </div>

                                        <div class="field col-12 md:col-4">
                                            <label>P&F Charges(₹)</label>
                                            <input type="text" pInputText class="w-full"
                                                formControlName="PackingForwarding">
                                        </div>
                                        <div class="field col-12 md:col-4">
                                            <label for="GSTRateOnPNF" class="font-semibold mb-1 block">Rate on
                                                P&F</label>
                                            <p-dropdown id="GSTRateOnPNF" class="w-full" [options]="gstOptions"
                                                optionLabel="label" optionValue="value" placeholder="Select GST"
                                                formControlName="GSTRateOnPNF">
                                            </p-dropdown>
                                        </div>
                                        <div class="field col-12 md:col-4">
                                            <label>GST on P&F(₹)</label>
                                            <input type="text" pInputText class="w-full"
                                                formControlName="GSTOnPNFAmount" readonly>
                                        </div>
                                    </div>
                                </div>
                                <div class="col flex flex-column align-items-end">
                                    <div class="field text-left">CGST: ₹
                                        {{CGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                    </div>
                                    <div class="field text-left">SGST: ₹
                                        {{CGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                    </div>
                                    <div class="field text-left">IGST: ₹
                                        {{IGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                    </div>
                                    <div class="field text-left">Taxable Amount: ₹
                                        {{Taxable.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                    </div>
                                    <div class="field">Final Taxable Amount: ₹
                                        {{FinalTaxableAmt.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                    </div>
                                    <div class="field text-left">
                                        <div class="hr-line"></div><br>
                                        <div style="display: flex; align-items: center;">
                                            <div style="margin-right: 10px;">Total Qty :
                                                <span>{{weightTotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                                </span>
                                            </div>
                                            <div style="margin: 0 10px;">|</div>
                                            <div>PO Total: ₹
                                                <span>{{orderTotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}</span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </form>
                        </ng-template>
                    </p-table>
                </p-tabPanel>

                <p-tabPanel header="PO Details"
                    [ngClass]="{'disabled-section':  purchaseOrderForm.controls.PurchaseOrder_Status.value === 'Rejected by POAdmin' || purchaseOrderForm.controls.PurchaseOrder_Status.value === 'Rejected'}">

                    <form [formGroup]="purchaseOrderForm">

                        <div class="grid">

                            <div class="col-12 md:col-4">

                                <div class="field text-left">
                                    <label for="Taxes">Taxes</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText formControlName="Taxes"
                                            (keydown.enter)="focusNextInput($event)" />
                                    </div>
                                </div>
                                <div class="field text-left">
                                    <label for="projectName">Project Name</label>
                                    <div style="display: flex; align-items: center; gap: 0.5rem;">
                                        <input pInputText formControlName="projectName" readonly placeholder="Select Project" style="width: 200px;" />
                                        <p-button icon="pi pi-search" (click)="getProduct()" [raised]="true" [size]="'small'" severity="info"
                                            [disabled]="canEdit"></p-button>
                                        <button *ngIf="purchaseOrderForm.get('projectName')?.value" type="button" pButton pRipple icon="pi pi-times"
                                            class="p-button-danger" severity="danger" (click)="clearProject()" title="Clear Project"
                                            [disabled]="canEdit"></button>

                                                                                <div style="margin-left: 10px;">
                                        <p-button icon="pi pi-plus" (onClick)="createQuickProject()" [link]="true" label="New Project" [size]="'small'"
                                            [disabled]="purchaseOrderForm.get('projectName')?.disabled">
                                        </p-button>
                                    </div>
                                    </div>


                                </div>
                                <div class="field text-left">
                                    <label for="Freight">Freight Type</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText formControlName="Freight"
                                            (keydown.enter)="focusNextInput($event)" />
                                    </div>
                                </div>

                                <div class="field text-left">
                                    <label for="quoteRefNo">Quotation/Ref No</label>
                                    <input pInputText formControlName="quoteRefNo" class="w-full"
                                        (keydown.enter)="focusNextInput($event)" />
                                </div>


                            </div>

                            <div class="col-12 md:col-4">

                                <div class="field text-left">
                                    <label for="Transport">Transport</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText formControlName="Transport"
                                            (keydown.enter)="focusNextInput($event)" />
                                    </div>
                                </div>

                                <div class="field text-left">
                                    <label for="Delivery">Delivery To</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText formControlName="Delivery"
                                            (keydown.enter)="focusNextInput($event)" />
                                    </div>
                                </div>

                                <div class="field text-left">
                                    <label for="Quality">Inspection Terms</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText formControlName="Quality"
                                            (keydown.enter)="focusNextInput($event)" />
                                    </div>
                                </div>

                                <div class="field text-left">
                                    <label for="quoteDate">Quotation Date</label>
                                    <div class="p-inputgroup p-lookup">
                                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy"
                                            formControlName="quoteDate" [showIcon]="true" placeholder="Select Date"
                                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.quoteDate.errors }"
                                            styleClass="w-full" (keydown.enter)="focusNextInput($event)">
                                        </p-calendar>
                                    </div>
                                </div>

                            </div>

                            <div class="col-12 md:col-4">

                                <div class="field text-left">
                                    <label for="termsCode">Payment Terms</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText formControlName="termsCode" readonly
                                            (keydown.enter)="focusNextInput($event)" />
                                        <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                            (click)="getTermsCode()"
                                            [disabled]="purchaseOrderForm.get('termsCode')?.disabled">
                                        </button>
                                        <p-button id="quickPaymentTerms" class="p-button-outlined ml-2"
                                            icon="pi pi-plus" severity="info" (click)="createQuickPaymentTerms()"
                                            [disabled]="purchaseOrderForm.get('termsCode')?.disabled">
                                        </p-button>
                                    </div>
                                </div>


                                <div class="field text-left">
                                    <label for="Validity">Validity</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText formControlName="Validity"
                                            (keydown.enter)="focusNextInput($event)" />
                                    </div>
                                </div>

                                <div class="field text-left">
                                    <label for="purchaseOrderComment">Purchase Order Comment</label>
                                    <div class="p-inputgroup p-lookup">
                                        <textarea rows="2" cols="30" pInputTextarea
                                            formControlName="purchaseOrderComment"></textarea>
                                    </div>
                                </div>

                                <div class="field text-left">
                                    <label for="specialInstruction">Special Instruction</label>
                                    <div class="p-inputgroup p-lookup">
                                        <textarea rows="2" cols="20" pInputTextarea
                                            formControlName="specialInstruction"></textarea>
                                    </div>
                                </div>

                            </div>

                        </div>


                    </form>

                </p-tabPanel>

            </p-tabView>


        </form>
    </div>

</p-card>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<p-dialog header="Reason for Rejection" [(visible)]="visible" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '30vw' }" [draggable]="false"
    [resizable]="false">
    <div class="field text-left">
        <label>Comment</label>
        <div class="p-inputgroup p-lookup">
            <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="comment">
                </textarea>
        </div>
    </div>
    <div class="flex justify-content-end gap-2">
        <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small"
            (onClick)="visible = false"></p-button>
        <p-button label="Save" icon="pi pi-save" size="small" (onClick)="reject()" />
    </div>
</p-dialog>

<p-dialog header="Submit Options" [(visible)]="savePopupVisible" [modal]="true" [closable]="true"
    [dismissableMask]="true" (onHide)="onSavePopupHide()">

    <div class="flex gap-2">
        <p-button label="Submit" icon="pi pi-save" (click)="saveOnly()">
        </p-button>

        <p-button label="Submit & Send" icon="pi pi-send" (click)="saveAndSend()">
        </p-button>
    </div>
</p-dialog>

<p-dialog header="Reason for Rejection for Po Admin" [(visible)]="visiblePoAdmin" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '30vw' }" [draggable]="false"
    [resizable]="false">
    <div class="field text-left">
        <label>Comment</label>
        <div class="p-inputgroup p-lookup">
            <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="comment">
                </textarea>
        </div>
    </div>
    <div class="flex justify-content-end gap-2">
        <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small"
            (onClick)="visiblePoAdmin = false"></p-button>
        <p-button label="Save" icon="pi pi-save" size="small" (onClick)="rejectPoAdmin()" />
    </div>
</p-dialog>

<p-dialog header="Comment" [(visible)]="showUpdateCommentDialog" [modal]="true" [style]="{ width: '400px' }"
    (onHide)="resetUpdateComment()">

    <div class="field" style="text-align: left;">
        <label for="updateComment" style="display: block; text-align: left; margin-bottom: 6px;">
            Comment
        </label>

        <textarea id="updateComment" pInputTextarea [(ngModel)]="updateComment" rows="4" class="w-full">
    </textarea>
    </div>


    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" (click)="showUpdateCommentDialog=false">
        </p-button>

        <p-button label="Save" severity="success" (click)="confirmUpdateApprovedPO()">
        </p-button>
    </ng-template>

</p-dialog>

<p-dialog header="Approve Options" [(visible)]="approvePopupVisible" [modal]="true" [closable]="true"
    [dismissableMask]="true" (onHide)="approvePopupVisible = false">
    <div class="flex gap-2">
        <p-button label="Approve" icon="pi pi-check" (click)="approveOnly()">
        </p-button>
        <p-button label="Send &amp; Approve" icon="pi pi-send" (click)="approveAndSend()">
        </p-button>
    </div>
</p-dialog>